import { DashboardLayout } from "src/components/dashboard";
import styled from "styled-components";
import searchIcon from "src/assets/images/input/searchIcon.svg";
import addIcon from "src/assets/images/common/add.svg";
import AdminTable from "src/components/admin/AdminTable";
import { useEffect, useState } from "react";
import AddAdminModal from "src/components/admin/addAdminModal/AddAdminModal";
import { theme } from "src/styles/Theme";
import { Input } from "src/components/inputs";
import { Flex, Button, ButtonClass } from "src/components/ui";
import { AdminTypes } from "./adminTypes";
import Loader from "src/components/common/Loader";
import { useLoading } from "src/hooks";
import { toast, ToastContainer } from "react-toastify";
import AppModal from "src/components/ui/widget/Modal/Modal";
import { PaginationProps } from "src/components/ui/Pagination";
import ModalContent from "src/components/common/ModalContent";
import {
  useGetAllAdminsQuery,
  useGetActivityLogsQuery,
} from "src/store/services/adminApi";

const AdminContainer = styled.div`
  .table-entry-status {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    font-weight: 700;
    font-size: 32px;
    font-style: italic;
  }
`;

interface Props {
  handleOpen: (e: any) => void;
  handleChange: (e: any) => void;
  handleExport?: () => void;
  action?: string;
}

export const RhsHeading: React.FC<Props> = ({
  handleChange,
  handleOpen,
  handleExport,
  action,
}) => (
  <Flex wrap="wrap">
    <Button
      onClick={handleExport}
      classes={[ButtonClass.SOLID, ButtonClass.WITH_ICON]}
      style={{ backgroundColor: theme.colors.purple, height: "48px" }}
    >
      <span>
        {" "}
        {action === "Occupation" ? " Export" : " Export Activity Log"}
      </span>
    </Button>

    <Input
      icon={<img src={searchIcon} alt="searchIcon" />}
      type="search"
      placeholder="Search"
      handleChange={handleChange}
    />

    <Button
      onClick={handleOpen}
      classes={[ButtonClass.SOLID, ButtonClass.WITH_ICON]}
      style={{
        backgroundColor: theme.colors.purple,
        height: "48px",
        width: "190px",
      }}
    >
      <img src={addIcon} alt="plus" width={24} height="24px" />
      <span>Add new {action ? action : "admin"}</span>
    </Button>
  </Flex>
);

const Admin = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [allAdmins, setAllAdmins] = useState<AdminTypes[]>([]);
  const [showExportModal, setShowExportModal] = useState(false);
  const [searchField, setSearchField] = useState("");
  const [shouldExport, setShouldExport] = useState(false);
  const [paginationData, setPaginationData] = useState<PaginationProps>({
    page: 0,
    pageSize: 0,
    total: 0,
    totalPages: 0,
  });
  const [pageNo, setPageNo] = useState(1);

  useEffect(() => {
    document.title = "Admin Page";
  }, []);

  const {
    loading: exportingData,
    startLoading: startExportingData,
    stopLoading: stopExportingData,
  } = useLoading(false);

  // RTK: get admins
  const {
    data: adminsResp,
    isLoading: isLoadingAdmins,
    refetch,
  } = useGetAllAdminsQuery({ page: pageNo, limit: 10, search: searchField });
  useEffect(() => {
    const rows: any[] = adminsResp?.payload?.data || [];
    const pagination = adminsResp?.payload?.pagination;
    setAllAdmins(rows as any);
    setPaginationData(pagination);
  }, [adminsResp, searchField]);

  // Trigger activity logs when shouldExport flips true
  const { data: activityResp } = useGetActivityLogsQuery(undefined, {
    skip: !shouldExport,
  });
  useEffect(() => {
    if (!shouldExport || !activityResp) return;
    const url = activityResp?.payload?.data?.fileUrl;
    if (url) {
      toast.success(activityResp?.message || "Export started");
      window.location.href = url;
    }
    setShouldExport(false);
    setShowExportModal(false);
    stopExportingData();
  }, [activityResp, shouldExport, stopExportingData]);

  const dumpActivityLogData = async () => {
    startExportingData();
    setShouldExport(true);
  };

  const filteredData = allAdmins;
  const handleChange = (e: any) => {
    setSearchField(e.target.value);
  };
  return (
    <DashboardLayout
      pageTitle="Admin"
      rhsHeading={
        <RhsHeading
          handleChange={handleChange}
          handleOpen={handleOpen}
          handleExport={() => setShowExportModal(!showExportModal)}
        />
      }
    >
      <ToastContainer />
      <AdminContainer>
        <AddAdminModal
          open={open}
          fetchAdmins={() => refetch()}
          handleClose={handleClose}
        />
        {isLoadingAdmins ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "100px",
            }}
          >
            <Loader>loading...</Loader>{" "}
          </div>
        ) : filteredData.length > 0 ? (
          <AdminTable
            rows={filteredData}
            pgn={pageNo}
            setpgn={setPageNo}
            paginationData={paginationData}
          />
        ) : (
          <p className="table-entry-status">No Admin Found</p>
        )}
      </AdminContainer>
      <AppModal
        open={showExportModal}
        onClose={() => setShowExportModal(false)}
        content={
          <ModalContent
            content1={"Export Activity Log"}
            content2="Are you sure you want to export activity log?"
            btnAction={dumpActivityLogData}
            linkContent={"Yes, Please"}
            onClick={() => setShowExportModal(false)}
            loading={exportingData}
          />
        }
      />
    </DashboardLayout>
  );
};

export default Admin;
